import { createSelector } from '@reduxjs/toolkit';
import { currentChatActiveReplyMessageSelector } from './currentChatActiveReplyMessage';

export const currentChatActiveReplyMessageIdSelector = createSelector(
  [currentChatActiveReplyMessageSelector],
  currentChatActiveReplyMessage => currentChatActiveReplyMessage?.messageId,
);
